// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './Figure.less';

/**
 * Figure component.
 */
const Figure = ({ baseClassName, className, href, caption, children, ...props }) => (
    <figure className={classNames(baseClassName, className)} {...props}>
        {children}
        {href && <a href={href} className={classNames(`${baseClassName}__overlay`, `${baseClassName}__overlay--cover`, `${baseClassName}__action`)} />}
        {caption && <figcaption className={classNames(`${baseClassName}__overlay`, `${baseClassName}__overlay--bottom`)}>{caption}</figcaption>}
    </figure>
);
Figure.propTypes = {
    href: PropTypes.string,
    caption: PropTypes.any,
    /**
     * Content of the figure
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Figure.defaultProps = {
    href: null,
    caption: null,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}figure`,
};

export default Figure;



// WEBPACK FOOTER //
// ./components/Figure/Figure.js